// extracted by mini-css-extract-plugin
export default {"products":"ut-z","card":"vt-z","oosMessaging":"wt-z"};